import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  lessonLimitsContainer: {
    padding: theme.spacing(0.5, 2, 0, 2),
  },
  actions: {
    padding: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  pricingContainer: {
    padding: theme.spacing(2),
  },
});
